import { render, staticRenderFns } from "./BaseEditForm.vue?vue&type=template&id=23f5d374&scoped=true&"
import script from "./BaseEditForm.vue?vue&type=script&lang=js&"
export * from "./BaseEditForm.vue?vue&type=script&lang=js&"
import style0 from "./BaseEditForm.vue?vue&type=style&index=0&id=23f5d374&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f5d374",
  null
  
)

export default component.exports